var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeekCornerEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112 88",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28 L56 54 L102 28 V70 C102 76 97 80 92 80 H20 C14 80 10 76 10 70 V28 Z",
    fill: "#c4c4c4",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28 L56 52 L102 28 C102 22 97 18 92 18 H20 C14 18 10 22 10 28 Z",
    fill: "#b0b0b0",
    opacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28 L56 52 L102 28",
    stroke: "#9a9a9a",
    strokeWidth: 2,
    strokeLinejoin: "round",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekCornerEnvelope);
export default __webpack_public_path__ + "static/media/week-corner-envelope.fa6d0b68b866ad5e86da986857cfca9e.svg";
export { ForwardRef as ReactComponent };